import { BaseWebComponentRepository } from '../../../framework/BaseWebComponentRepository';
import { MaintenanceWindowManuallyApprovedPatchesSelectorDataProviderFactory } from '../factory/MaintenanceWindowManuallyApprovedPatchesSelectorDataProviderFactory';
import { MaintenanceWindowManuallyApprovedPatchesSelectorBaseDataProvider } from '../dataProvider/MaintenanceWindowManuallyApprovedPatchesSelectorBaseDataProvider';
import { ManuallyApprovedPatch } from '../types';

export class MaintenanceWindowManuallyApprovedPatchesSelectorRepository extends BaseWebComponentRepository {
  public dataProviderFactory: MaintenanceWindowManuallyApprovedPatchesSelectorDataProviderFactory;
  public dataProvider: MaintenanceWindowManuallyApprovedPatchesSelectorBaseDataProvider;

  private patchesByCompany: { [companyId: string]: ManuallyApprovedPatch[] } = {};

  constructor() {
    super();
    this.initialSetup({
      dataProviderFactory: new MaintenanceWindowManuallyApprovedPatchesSelectorDataProviderFactory(),
    });
  }

  public async getManuallyApprovedPatchesForCompany(companyId: string): Promise<ManuallyApprovedPatch[]> {
    if (this.patchesByCompany[companyId]) {
      return this.patchesByCompany[companyId];
    }

    const patches = await this.dataProvider.getManuallyApprovedPatchesForCompany(companyId);

    if (patches.length > 0) {
      // Cache only the successful responses containing at least 1 patch
      this.patchesByCompany[companyId] = patches;
    }

    return patches;
  }
}
